define('mailsListView',[
    'app',
    'module',
    'marionette',
    'underscore',
    'mailsListSearchView',
    'mailsListMailsView',
    'mailsListLabelsFilterView',
    'template!mailsListView'
], function (
    App,
    Module,
    Marionette,
    _,
    SearchView,
    MailsView,
    LabelsFilterView,
    Tpl
) {
    'use strict';

    Module.exports = Marionette.LayoutView.extend({
        template: Tpl,
        className: 'list-view',

        regions: {
            labelsFilterRegion: '.labels-filter-region',
            searchRegion: '.search-region',
            mailsRegion: '.mails-region'
        },

        initialize: function() {
            this.mailsView = new MailsView({
                parentView: this
            });

            this.searchView = new SearchView({
                parentView: this
            });
            this.searchView.on('search', this.onSearch, this);
            
            this.labelsFilterView = new LabelsFilterView({
                parentView: this
            });
            this.labelsFilterView.on('filter:labels', this.onFilterLabels, this);
            this.labelsFilterView.on('filter:clear', this.onClearLabelsFilter, this);
        },

        onRender: function() {
          this.getRegion('mailsRegion').show(this.mailsView);
          this.getRegion('searchRegion').show(this.searchView);
          this.getRegion('labelsFilterRegion').show(this.labelsFilterView);
        },

        onSearch: function(value) {
            this.mailsView.search(value);
        },
        
        onFilterLabels: function(selectedLabels) {
            this.mailsView.filterByLabels(selectedLabels);
        },
        
        onClearLabelsFilter: function() {
            this.mailsView.clearLabelsFilter();
        }
    });
});
